import React  from 'react';
import type { ButtonHTMLAttributes } from 'react';
import { MaterialIcon } from '../../../components';
import { GLOBAL_ICONS } from '../../../util/vars';
import { DateTime } from 'luxon';
import { useI18n } from '@whizz/react-i18n';

type Ref = HTMLButtonElement;
type HTMLProps = ButtonHTMLAttributes<Ref>;

const CustomDateInput = React.forwardRef<Ref, HTMLProps>(({ value, onClick }, ref): JSX.Element => {
  const { locale, translate } = useI18n();
  const isToday = (date: DateTime) => date.toISODate() === DateTime.local().toISODate();
  const date = DateTime.fromFormat(value as string, 'MM/dd/yyyy', { locale: locale?.id });

  return (
    <button ref={ref} type={'button'} onClick={onClick}>
      <div className={'flex items-center'}>
        <div className={'italic border-b p-sm whitespace-nowrap'}>
          {isToday(date) ? translate('global.TODAY') : date.toLocaleString()}
        </div>
        <div className={'ml-sm'}>
          <MaterialIcon
            icon={GLOBAL_ICONS.calendar}
            size={'sm'}
            color={'dark'}
          />
        </div>
      </div>
    </button>
  );
});

CustomDateInput.displayName = 'CustomDateInput';

export default CustomDateInput;
